
let React =            require("react");

let LoadingCard =      require("./../cards/LoadingPlaceholder.jsx");
let Thumbnail =        require("./../cards/Thumbnail.jsx");

class SwitchThumbnail extends React.Component {

    constructor() {
        super();
        
        this.buttons = [];
        this.currentIndex = 1;
        this.state = {thumbnail: false, prevAction: null};

        this.toggle = this.toggle.bind(this);
    }

    toggle(event){
        event.stopPropagation();

        let method;
        if(this.currentIndex+1 < this.buttons.length){
            this.currentIndex = this.currentIndex+1;
            method = this.buttons[this.currentIndex];
        }else{
            this.currentIndex = 0;
            method = this.buttons[0];
        }

        this.getThumbnail(method, this.props.id, this.currentIndex)
    }

    getThumbnail(method, id, index){
        if(!method){
            this.setState({CurrentThumbnail: this.props.ByDefault});
        }
        else if(this.state.thumbnail){
            this.setState({CurrentThumbnail: this.makeThumbnail(this.state)});
        }
        else if(method){
            this.setState({CurrentThumbnail: () => <LoadingCard/>});
            method(id)
                .then(({thumbnail, name, summary}) => {
                    this.setState({thumbnail, name, summary, CurrentThumbnail: this.makeThumbnail({thumbnail, name, summary})})
                })
                .catch(() => this.setState({CurrentThumbnail: this.getBlackSquare(this.props.blackSquare)}));
        }
        this.changeHighlighted(index);
    }
    
    changeHighlighted(index){
        this.container.querySelector(`.selected`).classList.remove("selected")
        this.container.querySelector(`[data-index="${index}"]`).classList.add("selected")
    }


    getBlackSquare({minWidth = "40px", minHeight = "37px", width = "100%", position = "absolute", 
                    background = "black", top = "", height = "100%"} = {}){
        return () => <div style={{ minWidth, minHeight, width, height, position, background, top, height}}></div>;
    }

    makeThumbnail({thumbnail, name, summary}){
        let {Action} = this.props;
        let style = {position: "absolute", width: "100%", display: "flex", justifyContent: "center", alignItems: "center"};
        let BlackSquare = this.getBlackSquare(this.props.blackSquare);

        return () => <React.Fragment>
                        <BlackSquare/>
                        <Action style={style}
                            Content={()=>   <Thumbnail src={thumbnail} 
                                                className="image_2d"
                                                alt={`${name}\n${summary}`} 
                                            />}
                            />
                    </React.Fragment>
    }

    render() {
        this.buttons = [];
        let { ByDefault, show, thumbnails, id, addedClass = "", hasVersions } = this.props;
        let { CurrentThumbnail = ByDefault } = this.state;
        return  <React.Fragment>
                    {show && hasVersions &&
                        <div className={`switchThumbnail ${addedClass}`} onClick={this.toggle} ref={div => this.container = div}>
                            {thumbnails.map(({name, onClick: method, selected = false}, index) => {
                                this.buttons = [...this.buttons, method];
                                return  <div key={`${id}-${name}`} data-index={index}
                                            className={selected? "switchThumbnail__option selected": "switchThumbnail__option"}>
                                            {name}
                                        </div>}
                            )}
                        </div>
                    }
                    <CurrentThumbnail/>
                </React.Fragment>
    }

}

module.exports = SwitchThumbnail;
